export enum ACCESS_COL_IDS {
  NAME = 'name',
  EMAIL = 'email',
  EDIT = 'edit',
  VIEW = 'view',
  ACTIONS = 'actions'
}

export const TRUNCATE_NAME_WIDTH = 100;
